import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { createPortal } from "react-dom";
import { StyleProvider } from "./Layout/StyleProvider.js";
const Portal = memo((props) => createPortal(/* @__PURE__ */ jsx(StyleProvider, { children: props.children }), props.to ?? document.getElementById("portal-root") ?? document.body));
Portal.displayName = "Portal";
function getPortalRoot() {
  return document.getElementById("portal-root") ?? document.body;
}
export {
  Portal,
  getPortalRoot
};
//# sourceMappingURL=Portal.js.map
